import { render, staticRenderFns } from "./PublishingContractsConditionsReadOnlyPanel.vue?vue&type=template&id=819e6c0c"
import script from "./PublishingContractsConditionsReadOnlyPanel.vue?vue&type=script&lang=js"
export * from "./PublishingContractsConditionsReadOnlyPanel.vue?vue&type=script&lang=js"
import style0 from "./PublishingContractsConditionsReadOnlyPanel.vue?vue&type=style&index=0&id=819e6c0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports